import { render, staticRenderFns } from "./SiteHome.vue?vue&type=template&id=4795336e"
import script from "./SiteHome.vue?vue&type=script&lang=ts"
export * from "./SiteHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports